import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#060709] text-[#f4f4f7] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="gold-card rounded-2xl p-8 md:p-12 max-w-xl w-full text-center">
        <XCircle className="w-12 h-12 text-[#c9a24d] mx-auto mb-4" />
        <h1 className="font-disp text-2xl md:text-3xl text-white mb-3">{t("canc.title")}</h1>
        <p className="text-sm text-[#8c98a9] mb-6">
          {t("canc.text")}
        </p>
        <Link to="/" data-testid="retry-booking-link"
          className="inline-block font-geom px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] bg-gradient-to-r from-[#c9a24d] via-[#d9b86c] to-[#a17c2e] text-[#060709] rounded-full">
          {t("canc.btn")}
        </Link>
      </div>
    </div>
  );
}
